(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vegaEmbed"));
	else if(typeof define === 'function' && define.amd)
		define("world", ["vegaEmbed"], factory);
	else if(typeof exports === 'object')
		exports["world"] = factory(require("vegaEmbed"));
	else
		root["world"] = factory(root["vegaEmbed"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition